import React from 'react';
import { ChevronLeft, ChevronRight, Search, Filter, ChevronDown, Activity } from 'lucide-react';
import { formatDateLabel } from '../../utils';
import styles from './AppointmentToolbar.module.css';

const STATUS_OPTIONS = [
    ['all', 'All status'], ['Confirmed', 'Confirmed'], ['Waiting', 'Waiting'], ['In_Service', 'In service'],
    ['Completed', 'Completed'], ['Cancelled', 'Cancelled'], ['No_Show', 'No show'],
];

export default function AppointmentToolbar({
    selectedDate, onChangeDate, setToday, search, onSearch, staffFilter, onFilter, staffList,
    statusFilter = 'all', onStatusFilter,
}) {
    return (
        <section className={styles.controlBar}>
            <div className={styles.dateControls}>
                <button type="button" className={styles.iconBtn} onClick={() => onChangeDate(-1)} aria-label="Previous day"><ChevronLeft size={16} /></button>
                <button type="button" className={styles.todayBtn} onClick={setToday}>Today</button>
                <button type="button" className={styles.iconBtn} onClick={() => onChangeDate(1)} aria-label="Next day"><ChevronRight size={16} /></button>
                <span className={styles.selectedDateText}>{formatDateLabel(selectedDate)}</span>
            </div>

            <div className={styles.filters}>
                <div className={styles.searchBox}>
                    <Search size={14} className={styles.iconMuted} />
                    <input type="text" placeholder="Search client, mobile or service..." value={search} onChange={(e) => onSearch(e.target.value)} aria-label="Search appointments" />
                </div>
                {staffList.length > 1 && (
                <div className={styles.selectBox}>
                    <Filter size={13} className={styles.iconMuted} />
                    <select value={staffFilter} onChange={(e) => onFilter(e.target.value)} aria-label="Filter by staff">
                        <option value="all">All staff</option>
                        {staffList.map((s) => <option key={s._id} value={s._id}>{s.name}</option>)}
                    </select>
                    <ChevronDown size={13} className={styles.iconMuted} />
                </div>
                )}
                {onStatusFilter && (
                    <div className={styles.selectBox}>
                        <Activity size={13} className={styles.iconMuted} />
                        <select value={statusFilter} onChange={(e) => onStatusFilter(e.target.value)} aria-label="Filter by status">
                            {STATUS_OPTIONS.map(([value, label]) => <option key={value} value={value}>{label}</option>)}
                        </select>
                        <ChevronDown size={13} className={styles.iconMuted} />
                    </div>
                )}
            </div>
        </section>
    );
}